function positionSliderNav() {
  var winWidth = $(window).width();

  if (winWidth >= sliderMobileBreakpoint) {
    // clear positioning styles for dots
    $('.slider.restaurant .dotsWrapper, .slider.retail .dotsWrapper').removeAttr('style');
  } else {
    // home restaurant slider
    var restSlidePicHeight = $('.slider.restaurant .slick-slide .pic').height();
    $('.slider.restaurant .dotsWrapper').css({'bottom':'auto','top':restSlidePicHeight + 'px'});

    // home retail slider
    var retailSlidePicHeight = $('.slider.retail .slick-slide .pic').height();
    $('.slider.retail .dotsWrapper').css({'bottom':'auto','top':retailSlidePicHeight + 'px'});
  }
}